export const FETCH_AFFILIATE_REPORT_LIST = {
  START: "FETCH_AFFILIATE_REPORT_LIST_START",
  SUCCESS: "FETCH_AFFILIATE_REPORT_LIST_SUCCESS",
  ERROR: "FETCH_AFFILIATE_REPORT_LIST_ERROR",
};

export const TOAST = {
  RESET: "RESET_AFFILIATE_REPORT_TOAST",
};

export const FETCH_AFFILIATE_REPORT_INIT = "FETCH_AFFILIATE_REPORT_INIT";

export const EXPORT_AFFILIATE_REPORT = {
  START: "EXPORT_AFFILIATE_REPORT_START",
  SUCCESS: "EXPORT_AFFILIATE_REPORT_SUCCESS",
  ERROR: "EXPORT_AFFILIATE_REPORT_ERROR",
};

export const DOWNLOAD_AFFILIATE_REPORT = {
  START: "DOWNLOAD_AFFILIATE_REPORT_START",
  SUCCESS: "DOWNLOAD_AFFILIATE_REPORT_SUCCESS",
  ERROR: "DOWNLOAD_AFFILIATE_REPORT_ERROR",
};

export const EMAIL_AFFILIATE_REPORT = {
  START: "EMAIL_AFFILIATE_REPORT_START",
  SUCCESS: "EMAIL_AFFILIATE_REPORT_SUCCESS",
  ERROR: "EMAIL_AFFILIATE_REPORT_ERROR",
};

export const FETCH_AFFILIATE_LOCATION_DD = {
  START: "FETCH_AFFILIATE_LOCATION_DD_START",
  SUCCESS: "FETCH_AFFILIATE_LOCATION_DD_SUCCESS",
  ERROR: "FETCH_AFFILIATE_LOCATION_DD_ERROR",
};

export const FETCH_AFFILIATE_NETWORK_DD = {
  START: "FETCH_AFFILIATE_NETWORK_DD_START",
  SUCCESS: "FETCH_AFFILIATE_NETWORK_DD_SUCCESS",
  ERROR: "FETCH_AFFILIATE_NETWORK_DD_ERROR",
};

export const CLEAR_AFFILIATE_EMAIL_DROPDOWNS = "CLEAR_AFFILIATE_EMAIL_DROPDOWNS";

export const SET_AFFILIATE_REPORT_FILTERS = "SET_AFFILIATE_REPORT_FILTERS";
export const CLEAR_AFFILIATE_REPORT_FILTERS = "CLEAR_AFFILIATE_REPORT_FILTERS";
export const SET_AFFILIATE_REPORT_TABLE_COLUMN_FILTERS = "SET_AFFILIATE_REPORT_TABLE_COLUMN_FILTERS";
export const CLEAR_AFFILIATE_REPORT_TABLE_COLUMN_FILTERS = "CLEAR_AFFILIATE_REPORT_TABLE_COLUMN_FILTERS";
export const SAVE_AFFILIATE_REPORT_TABLE_STATE = "SAVE_AFFILIATE_REPORT_TABLE_STATE";

export const FETCH_AFFILIATE_DEPENDENT_LOCATIONS_DD = {
  START: "FETCH_AFFILIATE_DEPENDENT_LOCATIONS_DD_START",
  SUCCESS: "FETCH_AFFILIATE_DEPENDENT_LOCATIONS_DD_SUCCESS",
  ERROR: "FETCH_AFFILIATE_DEPENDENT_LOCATIONS_DD_ERROR",
};

export const FETCH_AFFILIATE_DEPENDENT_NETWORKS_DD = {
  START: "FETCH_AFFILIATE_DEPENDENT_NETWORKS_DD_START",
  SUCCESS: "FETCH_AFFILIATE_DEPENDENT_NETWORKS_DD_SUCCESS",
  ERROR: "FETCH_AFFILIATE_DEPENDENT_NETWORKS_DD_ERROR",
};

export const CLEAR_AFFILIATE_DEPENDENT_DROPDOWNS = "CLEAR_AFFILIATE_DEPENDENT_DROPDOWNS";
